import defaultAxios from 'axios';

export const axios = defaultAxios.create();
export const client = (url: string) => axios.get(url).then((res) => res.data);
